var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62484 6.45834L6.3258 14.5194C6.40069 15.3807 7.12169 16.0417 7.9862 16.0417H12.0135C12.878 16.0417 13.599 15.3807 13.6738 14.5194L14.3748 6.45834M8.12484 6.25001V5.62501C8.12484 4.70454 8.871 3.95834 9.7915 3.95834H10.2082C11.1287 3.95834 11.8748 4.70454 11.8748 5.62501V6.25001M4.1665 6.45834H15.8332",
    stroke: "#FF3B30",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.267a794829cf379908177fcc3312ec80.svg";
export { ForwardRef as ReactComponent };